import React from 'react';
import {FormInline} from '../fragments/forms';
import Button from '../fragments/button';

import style from './style.css';

import {getGsheetURL} from '../../components/gsheet';


export default class DataSheetView extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      loading: true,
      sheet_id: null,
    };
  }

  componentDidMount() {
    window.addEventListener('message', ({data, origin}) => {
      if (origin !== window.location.origin) {
        return;
      }
      const {action, sheet_id} = data;
      if (action !== 'setDataSheet') {
        return;
      }
      this.setState({
        sheet_id,
        loading: false
      });
    });
    window.opener.postMessage({
      action: 'dataSheetReady'
    }, window.location.origin);
  }

  handleSave() {
    const {sheet_id} = this.state;
    window.opener.postMessage({
      action: 'updateData',
      sheet_id: sheet_id,
    }, window.location.origin);
    window.close();
  }

  render() {
    const {sheet_id, loading} = this.state;

    const url = getGsheetURL(sheet_id);

    return <div>
      <FormInline>
        <Button
         btnStyle="primary" pullRight
         disabled={loading}
         onClick={this.handleSave.bind(this)}>
          Save and Close Window
        </Button>
      </FormInline>
      <iframe src={url} className={style.iframe} />
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/views/gsheet/index.js